import React, {useState, useEffect, useRef} from 'react';
import './ImagePreview.scss';
import { Button, Col, Container, Row } from 'react-bootstrap';
import MainLayout from '../../layouts/MainLayout';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import {
    AiOutlineClose as CloseCircleIcon,
    AiOutlineArrowLeft as LeftArrow,
    AiOutlineArrowRight as RightArrow
} from 'react-icons/ai';
import SimpleBar from 'simplebar-react';
import UserAnalytic from '../../helpers/UserAnalytic';

export const DFLT_ICO_PROPS = {
    height: '24px',
    width:  '24px',
    color: 'inherit'
};

export const TODO_ICO_PROPS = {
    height: '32px',
    width:  '32px',
    color: 'inherit'
};

const API_URL = process.env.REACT_APP_PORTAL_API;

export const ImageLazyLoading = ({
    src, className,
    loadingStyle,
}) => {
    const imgRef = useRef(null);
    const [isLoading, setLoadingStatus] = useState(true);
    useEffect(() => {
        if (!imgRef.current) return;
        if (imgRef.current.complete) {
            setLoadingStatus(false);
        }
    }, [imgRef]);
    useEffect(() => {
        setLoadingStatus(true);
    }, [src])
    let imgStyle = null;
    if (isLoading) {
        imgStyle = {
            display: 'hidden',
            height: 0,
            width: 0,
            border: 'none'
        };
    }
    return (
        <>
            {isLoading &&
            <div className={'comp-dp-image-loading ' + (className || '')}>
                <div className="loader" style={loadingStyle || {}}></div>
            </div>}
            <img
                style={imgStyle}
                src={src}
                className={className}
                onLoad={() => setLoadingStatus(false)}
            />
        </>
    );
}

const ImagePreview = ({
    session, images,
    onClose
}) => {
    const [currentIndex, setIndex] = useState(0);
    const safeImages = (Array.isArray(images) ? images : []);
    const currentImageSrc = safeImages[currentIndex];
    const handlePreviousPage = () => {
        const newPage = currentIndex - 1;
        UserAnalytic.event({
            category: 'image_preview',
            action: 'Previous (Page ' + newPage + ')',
        });
        if (newPage >= 0) {
            setIndex(newPage);
        }
    };
    const handleNextPage = () => {
        const newPage = currentIndex + 1;
        UserAnalytic.event({
            category: 'image_preview',
            action: 'Next (Page ' + newPage + ')',
        });
        if (newPage < images.length) {
            setIndex(newPage);
        }
    };
    useEffect(() => {
        const onKeyboard = (e) => {
            if (e.key === 'ArrowRight') {
                handleNextPage();
            } else if (e.key === 'ArrowLeft') {
                handlePreviousPage();
            }
        };
        document.addEventListener('keyup', onKeyboard);
        return () => {
            document.removeEventListener('keyup', onKeyboard);
        };
    })
    return (
        <div className="comp-dp-image-preview">
            <div className="c-dp-ip-list">
                    <SimpleBar
                        forceVisible="y"
                        autoHide={true}
                        style={{
                            maxHeight: '100vh',
                            transition: 'all 200ms'
                        }}
                    >
                        {safeImages.map((src, idx) => (
                            <div
                                key={src}
                                onClick={() => setIndex(idx)}
                                className="c-dp-ip-list-elm p-2"
                            >
                                <ImageLazyLoading
                                    src={src + '?token='+ session.token}
                                    className="shadow"
                                    loadingStyle={{
                                        height: 64,
                                        width: 64,
                                    }}
                                />
                            </div>
                        ))}
                    </SimpleBar>
            </div>
            <div className="c-dp-ip-img">
                <ImageLazyLoading src={currentImageSrc + '?token='+ session.token} className="h-100"/>
            </div>
            <div className="c-dp-ip-page p-2 d-flex align-items-center">
                <Button
                    variant="link"
                    className="link-primary"
                    disabled={currentIndex - 1 < 0 ? true : false}
                    onClick={() => {
                        handlePreviousPage();
                    }}
                >
                    <LeftArrow size={32} />
                </Button>
                <span className="ps-3 pe-3">
                    {currentIndex + 1} / {safeImages.length}
                </span>
                <Button
                    variant="link"
                    className="link-primary"
                    disabled={currentIndex + 1 >= safeImages.length ? true : false}
                    onClick={() => {
                        handleNextPage();
                    }}
                >
                    <RightArrow size={32} />
                </Button>
            </div>
            <div className="c-dp-ip-close p-4 pb-2">
                <Button
                    variant="link"
                    className="link-primary"
                    onClick={() => {
                        (onClose || function(){})();
                    }}
                ><CloseCircleIcon size={48}/></Button>
            </div>
        </div>
    );
}

const mapStateToProps = (appState) => ({
    userProfile: appState.userProfile,
    session: appState.session
});

const mapDispatchToProps = (dispatch) => ({ });

export default connect(mapStateToProps, mapDispatchToProps)(ImagePreview);